import ConnectionUtil from "shared/connection_util";
import { IsPremiumUser, getPlatform, QueryString, UserProvider, LocationMediator } from "shared/vidio_helpers";
import LocalStorageAdapter from "shared/localstorage_adapter";

export default class AhoyEvent {
  static track(eventLabel, eventProps) {
    const eventTitle = AhoyEvent.getEventTitle(eventLabel);
    const eventData = AhoyEvent.generateEventData(eventProps);

    return new Promise((resolve) => {
      AhoyEvent.send(eventTitle, eventData);
      resolve(true);
    });
  }

  static send(eventLabel, eventData) {
    const generatedEventData = this.generateEventData(eventData);

    if (['VIDIO::HOMEPAGE', 'VIDIO::CATEGORY_PAGE'].indexOf(eventLabel) !== -1) {
      generatedEventData.user_segment = this.getUserSegment();
    }

    window.ahoy.track(eventLabel, generatedEventData);

    if (QueryString.getParamValue(location.search, "ahoy_debug") === "1") {
      generatedEventData.visitor_id = window.ahoy.visitorId;
      generatedEventData.visit_id = window.ahoy.visitId;
      generatedEventData.user_id = window.ahoy.eventBuilder._userId;
      console.warn(eventLabel, "+++", JSON.stringify(generatedEventData));
    }
  }

  static getEventTitle(titleParam) {
    var title = titleParam ? titleParam : "UNTITLED";
    return "VIDIO::" + title.toUpperCase();
  }

  static generateEventData(eventData) {
    this._connectionUtil = this._connectionUtil || new ConnectionUtil();

    var ahoyData = {
      platform: getPlatform(),
      app_name: "vidio",
      page: window.location.href,
      referrer: document.referrer,
      ga_client_id: this.getGaClientId() || null,
      connection: this._connectionUtil.getConnectionEffectiveType(),
      event_time: new Date().toISOString(),
    };

    if (IsPremiumUser.get()) {
      ahoyData.user_type = "premier";
    }

    for (var index in eventData) {
      ahoyData[this.snakeCase(index)] = eventData[index];
    }

    AhoyEvent.extendProperties(ahoyData, eventData);
    return ahoyData;
  }

  static extendProperties(data, newData) {
    for (var index in newData) {
      data[AhoyEvent.snakeCase(index)] = newData[index];
    }

    return data;
  }

  static snakeCase(string) {
    return string.replace(/[A-Z][a-z]*/g, (x) => {
      return "_" + x.toLowerCase();
    });
  }

  static getGaClientId() {
    if (!window.ga) return null;

    var clientId;
    window.ga(function (tracker) {
      clientId = tracker.get("clientId");
    });
    return clientId;
  }

  static getUserSegment() {
    const variant = QueryString.getParamValue(LocationMediator.href(), 'variant');
    const isVariantValid = ['variant_a', 'variant_b'].includes(variant)

    const user_segment = [];
    if (isVariantValid) user_segment.push(variant);

    const segment = UserProvider.isUserSignedIn() ? LocalStorageAdapter.getItem('vidio_segments') : '';
    if (segment) user_segment.push(...JSON.parse(segment));

    if (user_segment.length > 0) return user_segment;
  }
}
